import React, { useEffect, useState } from "react";
import Select from "react-select";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { Link, useLocation } from "react-router-dom";
import Http from "../../../Common/Http";
import DatatableFunc from "../../../Common/DatatableFunc";
import Alert from "../../../Common/Alert";

const GetBankLedgerSummary = () => {
  const location = useLocation();
  const [bankData, setBankData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/get-bank-ledger-summary`);
      const resRole = await Http.get(`/staff-type-check`);
      setBankData(res.data.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);
  const cols = [
    { field: "name", header: "Bank Name" },
    { field: "account_number", header: "Account Number" },
    { field: "branch", header: "Branch" },
    { field: "total_deposit", header: "Total Deposit" },
    { field: "total_expense", header: "Total Expenses" },
    { field: "total_balance", header: "Balance" },
  ];
  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={{
            pathname: "/reports/get-bank-ledger-details/" + item.id,
          }}
          className="btn btn-info btn-sm ms-1"
          title="View Details"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {(role === "admin" || role === "accounts") && (
          <Link
            to={{
              pathname: "/edit-bank/" + item.id,
            }}
            className="btn btn-primary btn-sm ml-1"
            title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        )}
      </td>
      
    );
  };

  //  const actionTemplate = (item) => {
  //   return (
  //     <td className="text-xs text-center">
  //       <Link
  //         to={{
  //           pathname: "/view-bank/" + item.id,
  //         }}
  //         className="btn btn-info btn-sm ms-1"
  //         title="View Bank"
  //       >
  //         <i className="fa fa-list" aria-hidden="true"></i>
  //       </Link>
  //       {(role === "admin" || role === "accounts") && (
  //         <Link
  //           to={{
  //             pathname: "/edit-bank/" + item.id,
  //           }}
  //           className="btn btn-primary btn-sm ml-1"
  //           title="Edit"
  //         >
  //           <i className="fa fa-pencil" aria-hidden="true"></i>
  //         </Link>
  //       )}
  //     </td>
  //   );
  // };
 console.log(bankData,'bankData')
  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Banks</h5>
            <div className="am-right">
              {(role === "admin" || role === "accounts") && (
                <Link
                  to="/create-bank"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Bank
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={bankData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetBankLedgerSummary